import React, { useState } from 'react';
import { Phone, Mail, MapPin, Send, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-header-card">
          <div className="contact-header-content">
            <h2>Get in <span className="highlight">Touch</span></h2>
            <div className="underline"></div>
            <p>
              Have questions about BinBuddy? Want to learn more about how our 
              smart waste management solutions can help your community? Reach out to us.
            </p>
          </div>
        </div>

        <div className="contact-content">
          <div className="contact-form-box">
            <h3>Send us a Message</h3>
            <form onSubmit={handleSubmit}>
              <label htmlFor="name">Your Name</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />

              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />

              <label htmlFor="message">Your Message</label>
              <textarea id="message" name="message" rows={5} value={formData.message} onChange={handleChange} required></textarea>

              <button type="submit" className="submit-btn">
                <Send size={18} className="icon" /> Send Message
              </button>
            </form>
          </div>

          <div className="contact-info-box">
            <h3>Contact Information</h3>
            <div className="info-item">
              <div className="icon-box"><MapPin size={24} /></div>
              <div>
                <h4>Our Location</h4>
                <p>BinBuddy Headquarters<br />123 Green Tech Park<br />Bangalore, Karnataka 560001</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon-box"><Mail size={24} /></div>
              <div>
                <h4>Email Us</h4>
                <p>info@binbuddy.com</p>
                <p>support@binbuddy.com</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon-box"><Phone size={24} /></div>
              <div>
                <h4>Call Us</h4>
                <p>+91 1234 567 890</p>
                <p>+91 9876 543 210</p>
              </div>
            </div>

            <div className="social-section">
              <h4>Follow Us</h4>
              <div className="social-icons">
                <a href="#facebook" className="social-icon" aria-label="Facebook">
                  <Facebook size={20} />
                </a>
                <a href="#twitter" className="social-icon" aria-label="Twitter">
                  <Twitter size={20} />
                </a>
                <a href="#instagram" className="social-icon" aria-label="Instagram">
                  <Instagram size={20} />
                </a>
                <a href="#linkedin" className="social-icon" aria-label="LinkedIn">
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
